/**
 * buildOrchestratorTickContext — Assembles GameOrchestrator.tick context.
 * Presentation-only wiring; match clock from MatchRuntime (P3-01).
 */
export function buildOrchestratorTickContext({
  matchRuntime,
  activeMinions,
  blueSpawner,
  redSpawner,
  activeProjectiles,
  activeJungleCamps,
  mapBounds,
  wallBoxes,
  bushZones,
  impassableZones,
  recentDamageEvents,
  scene,
  mapObjectives,
  addMinionsToScene,
  MeshFactory
}) {
  return {
    ...matchRuntime.toOrchestratorEntityFields(),
    activeMinions,
    blueSpawner,
    redSpawner,
    activeProjectiles,
    activeJungleCamps,
    mapBounds,
    wallBoxes,
    bushZones,
    impassableZones,
    recentDamageEvents,
    scene,
    altars: mapObjectives.getAltars(),
    relics: mapObjectives.getRelics(),
    gameTime: matchRuntime.gameTime,
    visionState: matchRuntime,
    passiveGoldRate: matchRuntime.lastPlan?.passiveGoldRate,
    passiveXpRate: matchRuntime.lastPlan?.passiveXpRate,
    addMinionsToSceneCallback: addMinionsToScene,
    createFrostArrowMeshCallback: (isSkillshot) => MeshFactory.createFrostArrowMesh(isSkillshot),
    createTurretShotMeshCallback: (team) => MeshFactory.createTurretShotMesh(team)
  };
}
